import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import { app } from "./config/firebase";
import "./index.css";

// Ensure Firebase is initialized
console.log("Firebase app initialized:", app);

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>
);
